// SH Updated: March 2026 - Intercept REMOVE click for BYOB bundles to remove all child items
(function() {
  document.addEventListener('click', function(event) {
    var target = event.target.closest('[data-action="remove-item"]');
    if (!target) return;

    var bundleId = target.getAttribute('data-bundle-id');
    console.log('[BYOB] Remove clicked — checking for bundle...', { bundleId: bundleId });

    if (!bundleId) {
      console.log('[BYOB] Regular item, passing to theme handler');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var bundleKeys = target.getAttribute('data-bundle-keys').split('|').filter(Boolean);
    var updates = {};
    bundleKeys.forEach(function(key) { updates[key] = 0; });

    console.log('[BYOB] Bundle detected, id:', bundleId);
    console.log('[BYOB] Keys to remove:', bundleKeys);
    console.log('[BYOB] Sending update:', JSON.stringify(updates));

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        console.log('[BYOB] Remove complete, refreshing cart UI', data);

        if (window.location.pathname !== '/cart') {
          // Drawer: dispatch cart:refresh — theme's drawer instance handles re-render
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          return;
        }

        // Cart page: fetch fresh HTML and replace content manually
        fetch(window.Shopify.routes.root + 'cart?view=ajax&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;

            console.log('[BYOB] Fetched HTML length:', html.length);

            // Replace item list
            var currentItemList = document.querySelector('.Cart__ItemList');
            var newItemList = temp.querySelector('.Cart__ItemList');
            console.log('[BYOB] ItemList — current:', !!currentItemList, 'new:', !!newItemList);
            if (currentItemList && newItemList) {
              currentItemList.innerHTML = newItemList.innerHTML;
            }

            // Replace footer (totals + checkout)
            var currentFooter = document.querySelector('.Cart__Footer');
            var newFooter = temp.querySelector('.Cart__Footer');
            console.log('[BYOB] Footer — current:', !!currentFooter, 'new:', !!newFooter);
            if (currentFooter && newFooter) {
              currentFooter.innerHTML = newFooter.innerHTML;
            }

            // Replace page header (item count in "CART" heading)
            var currentHeader = document.querySelector('.PageHeader');
            var newHeader = temp.querySelector('.PageHeader');
            console.log('[BYOB] PageHeader — current:', !!currentHeader, 'new:', !!newHeader);
            if (currentHeader && newHeader) {
              currentHeader.innerHTML = newHeader.innerHTML;
            }

            // If cart is empty, replace entire section
            var newSection = temp.querySelector('[data-section-type="cart"]');
            var currentSection = document.querySelector('[data-section-type="cart"]');
            if (newSection && currentSection && !newItemList) {
              console.log('[BYOB] Cart empty — replacing entire section');
              currentSection.innerHTML = newSection.innerHTML;
            }

            // Update header cart count + dot
            if (newSection) {
              var settings = JSON.parse(newSection.getAttribute('data-section-settings'));
              var itemCount = settings.itemCount;
              console.log('[BYOB] New item count:', itemCount);

              document.querySelectorAll('.Header__CartDot').forEach(function(dot) {
                dot.classList.toggle('is-visible', itemCount > 0);
              });
              document.querySelectorAll('.Header__CartCount').forEach(function(el) {
                el.textContent = itemCount;
              });
            }

            // Trigger GWP refresh
            if (currentSection) {
              currentSection.dispatchEvent(new CustomEvent('gwp:refresh', { bubbles: true }));
            }

            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            console.log('[BYOB] Cart page UI updated');
          });
      })
      .catch(function(err) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        console.error('[BYOB] Error removing bundle:', err);
      });
  }, true);
})();
